/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEyeX = createReactComponent("eye-x", "IconEyeX", [
  ["path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M13.048 17.942a9.298 9.298 0 0 1 -1.048 .058c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a17.986 17.986 0 0 1 -1.362 1.975",
      key: "svg-1"
    }
  ],
  ["path", { d: "M22 22l-5 -5", key: "svg-2" }],
  ["path", { d: "M17 22l5 -5", key: "svg-3" }]
]);

export { IconEyeX as default };
//# sourceMappingURL=IconEyeX.js.map
